import React from "react";
import { Box, Paper, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import {
  BILLING_STATEMENT_LIST_ROUTE,
  ADMIN_BILLING_LIST,
} from "../../constants/RoutePath";

export default function BillingStatementMenu(props) {
  const navigate = useNavigate();
  const { getLogUserRole } = props;
  var menuTypeAdmin = false;
  var menuTypeBroker = false;
  if (getLogUserRole && getLogUserRole.length > 0) {
    for (let data of getLogUserRole) {
      if (data === "Admin") {
        menuTypeAdmin = true;
      }
      if (data === "Broker") {
        menuTypeBroker = true;
      }
    }
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#F6F7F9",
    ...theme.typography.body2,
    textAlign: "center",
    cursor: "pointer",
    color: theme.palette.text.secondary,
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    padding: "10px 14px",
    boxShadow: "none",
  }));

  const activeStyle = {
    background: "rgb(88, 168, 74)",
    color: "#FFF",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    padding: "10px 14px",
    borderRadius: "5px",
  };

  return (
    <Box sx={{ padding: "10px" }} className="bg-box user-log">
      {/* <Grid container>
              <Grid  xs={12} md={6}>
                <p>hhhh {menuType}</p>
              </Grid>
            </Grid> */}

      <Stack
        sx={{
          borderRadius: "10px",
          background: "#F6F7F9",
          padding: "5px",
          width: "fit-content",
        }}
        direction={{ xs: "column", sm: "row" }}
        spacing={{ md: 0 }}
      >
        {menuTypeBroker ? (
          <Item
            onClick={() => {
              navigate(BILLING_STATEMENT_LIST_ROUTE);
            }}
            style={
              location.pathname
                .toString()
                .includes(BILLING_STATEMENT_LIST_ROUTE)
                ? activeStyle
                : {}
            }
          >
            Billing Statement
          </Item>
        ) : (
          ""
        )}

        {menuTypeAdmin ? (
          <Item
            onClick={() => {
              navigate(ADMIN_BILLING_LIST);
            }}
            style={
              location.pathname.toString().includes(ADMIN_BILLING_LIST)
                ? activeStyle
                : {}
            }
          >
            {" "}
            Orphaned Billing Statement
          </Item>
        ) : (
          ""
        )}
      </Stack>
    </Box>
  );
}
